var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDialogBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79241 0C4.95668 0 4.28571 0.677005 4.28571 1.52027V2.16216H11.779C13.0735 2.16216 14.1429 3.24114 14.1429 4.5473V10.5878C14.1429 10.907 14.0775 11.2136 13.9621 11.4932L15.8571 13V9.51351H16.4933C17.329 9.51351 18 8.83651 18 7.99324V1.52027C18 0.677008 17.329 0 16.4933 0H5.79241ZM1.5067 3.02703C0.670961 3.02703 0 3.70403 0 4.5473V10.5878C0 11.4311 0.670961 12.1081 1.5067 12.1081H2.14286V15L6 12.1081H11.779C12.6148 12.1081 13.2857 11.4311 13.2857 10.5878V4.5473C13.2857 3.70403 12.6148 3.02703 11.779 3.02703H1.5067ZM3.64286 6.7027C4.11624 6.7027 4.5 7.08992 4.5 7.56757C4.5 8.04523 4.11624 8.43243 3.64286 8.43243C3.16948 8.43243 2.78571 8.04523 2.78571 7.56757C2.78571 7.08992 3.16948 6.7027 3.64286 6.7027ZM6.64286 6.7027C7.11624 6.7027 7.5 7.08992 7.5 7.56757C7.5 8.04523 7.11624 8.43243 6.64286 8.43243C6.16948 8.43243 5.78571 8.04523 5.78571 7.56757C5.78571 7.08992 6.16948 6.7027 6.64286 6.7027ZM9.64286 6.7027C10.1163 6.7027 10.5 7.08992 10.5 7.56757C10.5 8.04523 10.1163 8.43243 9.64286 8.43243C9.16948 8.43243 8.78571 8.04523 8.78571 7.56757C8.78571 7.08992 9.16948 6.7027 9.64286 6.7027Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogBlack);
export default __webpack_public_path__ + "static/media/dialog-black.509585e6155ad888504777d524086c0d.svg";
export { ForwardRef as ReactComponent };